<template>
  <!-- 页面标题：所有页面统一用它，不再各自写 <h2>；默认插槽里的内容（详情页的返回、保存等按钮）紧跟在标题后面 -->
  <div class="page-title">
    <span class="page-title-text">{{ title || route.meta.title }}</span>
    <slot />
  </div>
</template>

<script setup>
// defineProps 是编译宏，项目用的 eslint-plugin-vue 7 还不认识它
/* global defineProps */
import { useRoute } from 'vue-router'

defineProps({
  /** 标题文字，不传时取菜单里的页面名 */
  title: String,
})

const route = useRoute()
</script>

<style lang="less">
.page-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 20px;
  min-height: 32px;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--el-border-color-lighter);

  .page-title-text {
    position: relative;
    padding-left: 12px;
    font-size: 18px;
    font-weight: 600;
    line-height: 32px;
    color: var(--el-text-color-primary);

    // 标题前的主色竖条
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 4px;
      height: 18px;
      border-radius: 2px;
      background-color: var(--el-color-primary);
      transform: translateY(-50%);
    }
  }
}
</style>
